import { render, staticRenderFns } from "./SupplierOnboardingCoverage.vue?vue&type=template&id=f28684ba&"
import script from "./SupplierOnboardingCoverage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingCoverage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingCoverage.vue?vue&type=style&index=0&id=f28684ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports